import React, { useEffect, useState } from "react";

const ScrollBtn = () => {
    const [scrolling, setScrolling] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScrolling(window.scrollY > 500);
        });
    }, []);

    function scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }

    return (
        <a href="#home" className={scrolling ? 'scrollup show__scroll' : 'scrollup' } id="scroll-up" onClick={scrollToTop}>
            <i className="uil uil-arrow-up scrollup__icon"></i>
        </a>
    )
}

export default ScrollBtn;